import { motion } from "framer-motion";
import { MARQUEE_WORDS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section
      data-testid="marquee"
      className="py-16 md:py-24 bg-ink overflow-hidden select-none"
      aria-hidden="true"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ repeat: Infinity, ease: "linear", duration: 32 }}
      >
        {items.map((w, i) => (
          <span
            key={i}
            className="font-serif italic font-light text-5xl md:text-7xl leading-[1.15] text-paper px-8 flex items-center"
          >
            {w}
            <span className="text-clay not-italic mx-8 text-4xl md:text-6xl align-middle">
              &#8212;
            </span>
          </span>
        ))}
      </motion.div>
    </section>
  );
};
